import React from 'react'
import { useFormContext } from 'react-hook-form'
import CabecalhoTabelaHorarioForm from './CabecalhoForm'
import InterjornadaForm from './InterjornadaForm'
import PausasForm from './PausasForm'
import PreviewEspelhoForm from './PreviewEspelhoForm'
import { HorariosForm } from './TabelaHorariosForm'
import { TipoTabelaForm } from './TipoTabelaForm'
import { ToleranciasForm } from './ToleranciasForm'

export default function FormTabelaHorario() {
    const { watch } = useFormContext()
    const isSemanal = watch('tipo') === 'SEMANAL'

    const MemoizedPreviewEspelho = React.useMemo(
        () => <PreviewEspelhoForm />,
        [],
    )

    if (isSemanal) {
        return (
            <>
                <CabecalhoTabelaHorarioForm />
                <TipoTabelaForm />
            </>
        )
    }

    return (
        <>
            <CabecalhoTabelaHorarioForm />
            <TipoTabelaForm />
            <ToleranciasForm />
            <HorariosForm />
            {MemoizedPreviewEspelho}
            <PausasForm />
            <InterjornadaForm />
        </>
    )
}
